module.exports = __webpack_public_path__ + "static/media/machiup.cb4b2f24.svg";